export default "__VITE_ASSET__e77c11d5__"